/* globals gtag */

import React, {useCallback, useEffect, useMemo, useRef, useState} from "react"
import {useSelector} from "react-redux"
import "./ProductCard.css"
import Sticker from "../Sticker/Sticker"
import Configuration from "../Configuration/Configuration"
import Utils from "../../utils/Utils"
import Slider from "react-slick"
import $ from "jquery"
import getSymbolFromCurrency from "currency-symbol-map"
import Cookies from "universal-cookie"
import CartIcon from "../CartIcon/CartIcon";
import useAddToCartStatus from "../../hooks/useAddToCartStatus";
import Spinner from "../Spinner";

export function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false)
  const observer = useMemo(
    () =>
      !!ref &&
      new IntersectionObserver(([entry]) =>
        setIntersecting(entry.isIntersecting)
      ),
    [ref]
  )

  useEffect(() => {
    if (
      !!ref &&
      observer instanceof IntersectionObserver &&
      ref.current instanceof Element
    ) {
      observer.observe(ref.current)
      return () => observer?.disconnect()
    }
  }, [ref, observer])

  return isIntersecting
}

const ProductCard = (props) => {
  const addToCartBtn = useSelector((state) => state.config.addToCartBtn);
  const accentColor = useSelector((state) => state.config.accentColor)
  const card = useSelector((state) => state.config.card)
  const isSearching = useSelector((state) => state.isSearching)
  const hover = useSelector((state) => state.config.hover)
  const shopId = useSelector((state) => state.config.shopId)
  const isMobile = useSelector((state) => state.isMobile)
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const stickers = useSelector((state) => state.config.stickers)
  const asyncData = useSelector((state) => state.asyncData)
  const webhook = useSelector((state) => state.config.webhook)
  const placeholders = useSelector((state) => state.config.placeholders)
  const currencyCode = useSelector((state) => state.config.priceGroup.currency)
  const visitorType = useSelector((state) => state.config.priceGroup.id)
  const advancedCustomization = useSelector(
    (state) => state.advancedCustomization
  )
  const priceFormat = useSelector((state) => state.config.priceGroup.format)
  const placeholder = useSelector((state) => state.config.triggers.placeholder)
  const urlPrefix = useSelector((state) => state.urlPrefix)
  const imgPrefix = useSelector((state) => state.imgPrefix)
  const ga4 = useSelector((state) => state.config.ga4)
  const [hovered, setHovered] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [counter, setCounter] = useState(1)
  const [mounted, setMounted] = useState(false)
  const [isError, setIsError] = useState(false)
  const [fallback, setFallback] = useState(true)
  const [errorId, setErrorId] = useState(0)
  const [promoViewed, setPromoViewed] = useState(false)

  const promoRef = useRef(null)
  const isPromViewed = useOnScreen(promoRef)
  const cookies = new Cookies()

  const {display: showAddToCartBtn = false} = addToCartBtn || {};

  useEffect(() => {
    if (isPromViewed && !promoViewed) {
      setPromoViewed(true)
      Utils.sendAnalyticsObject(baseUrl, shopId, "as_view_promotion", {
        id: props.value.header.id,
        title: props.value.data[card.title.key],
      })
      if (!!ga4?.isActive) {
        if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
          window.dataLayer.push({
            event: "as_view_promotion",
            data: {
              id: props.value.header.id,
              title: props.value.data[card.title.key],
            },
          })
        } else if (typeof gtag !== "undefined") {
          gtag("event", "as_view_promotion", {
            id: props.value.header.id,
            title: props.value.data[card.title.key],
          })
        }
      }
    }
  }, [isPromViewed])

  let automaticDiscount = useMemo(() => {
    let adKey = null
    Object.entries(card).forEach(([key, value]) => {
      if (value.key === "automatic_discount") {
        adKey = key
      }
    })
    return adKey
  }, [card])

  const headerType = useMemo(() => {
    if (props.value.header === undefined) return null
    return props.value.header.type
  }, [props])

  var headerId = useMemo(() => props.value.header?.id, [props])
  var bannerResponsive = useMemo(
    () =>
      isMobile ? props.value.data?.mobileImageUrl : props.value.data?.imageUrl,
    [isMobile, props]
  )

  var children = useMemo(() => {
    if (!headerType) return []
    return headerType === "bundle" || headerType === "grouped"
      ? props.value.bundles
        ? props.value.bundles
        : []
      : props.value.variants
        ? props.value.variants
        : []
  }, [props, headerType])

  var [selectedProduct, setSelectedProduct] = useState(
    headerType === "simple" || !children[0]
      ? props.value.data
      : children[0].data
  )

  var getBundleConfigurations = useCallback((children) => {
    var bundleConfigurations = []
    // eslint-disable-next-line no-unused-expressions
    children[0]?.configurableAttributes?.forEach((configurableAttribute) => {
      var itemsToPush = []
      children.forEach((child) => {
        itemsToPush.push(child.data[configurableAttribute])
      })
      bundleConfigurations.push({
        configurableAttribute: configurableAttribute,
        items: itemsToPush,
      })
    })
    return bundleConfigurations
  }, [])

  var childrenToUse = useMemo(() => {
    var childrenToUse = []
    if (headerType === "bundle") {
      var bundleSelections = []
      children.forEach((child) => {
        if (bundleSelections.indexOf(child.data.bundle_selection) === -1)
          bundleSelections.push(child.data.bundle_selection)
      })
      bundleSelections.forEach((bundleSelection) => {
        var itemsToPush = []
        children.forEach((child) => {
          if (bundleSelection === child.data.bundle_selection)
            itemsToPush.push(child)
        })
        childrenToUse.push({
          bundleSelection: bundleSelection,
          items: itemsToPush,
        })
      })
    } else if (headerType === "configurable") {
      childrenToUse = {}
      if (!children[0]) return []
      var configurableAttributes = []
      hover.attributes.forEach((attribute) => {
        children[0].configurableAttributes.forEach((configurableAttribute) => {
          if (attribute.key === configurableAttribute)
            configurableAttributes.push(configurableAttribute)
        })
      })
      configurableAttributes.forEach((configurationAttribute) => {
        childrenToUse[configurationAttribute] = []
        children.forEach((child) => {
          if (
            childrenToUse[configurationAttribute].indexOf(
              child.data[configurationAttribute]
            ) === -1
          )
            childrenToUse[configurationAttribute].push(
              child.data[configurationAttribute]
            )
        })
      })
    }
    return childrenToUse
  }, [children, hover, headerType])

  const configurationActive = useMemo(
    () =>
      !hovered ||
      headerType === "simple" ||
      !children[0] ||
      headerType === "bundle" ||
      !hover.isActive ||
      hover.attributes.length === 0,
    [hovered, hover, children, headerType]
  )

  var isNewProduct = useMemo(() => {
    var valueToReturn =
      props.value &&
      props.prevValue &&
      props.value.header &&
      props.prevValue.header &&
      isSearching
        ? props.value.header.id !== props.prevValue.header.id
        : false
    return valueToReturn
  }, [props, isSearching])

  var currencySymbol = useMemo(
    () =>
      getSymbolFromCurrency(
        advancedCustomization
          ? advancedCustomization.currencyCode
          : currencyCode
      ),
    [advancedCustomization, currencyCode]
  )

  useEffect(() => {
    if (!hovered) {
      setSelectedProduct(props.value.data)
      // setSelectedProduct(headerType==="simple" || !children[0]?props.value.data:children[0].data);
      setMounted(true)
    }
    if (isNewProduct) {
      setErrorId(0)
      setLoaded(false)
      setIsError(false)
      setFallback(true)
    } else setLoaded(true)
    let hoverInterval
    if (hovered)
      hoverInterval = setInterval(() => setCounter(counter + 1), 1000)
    else clearInterval(hoverInterval)
    return () => clearInterval(hoverInterval)
  }, [
    children,
    setSelectedProduct,
    props,
    setLoaded,
    setIsError,
    setErrorId,
    isNewProduct,
    headerType,
    shopId,
    card,
    hovered,
    counter,
    setCounter,
    mounted,
    setMounted,
  ])

  const priceToShow = useMemo(() => {
    if (webhook.key !== "" && asyncData) {
      var asyncPrice =
        asyncData.filter((item) => item.id === props.value.data[webhook.key])
          .length > 0
          ? asyncData.filter(
            (item) => item.id === props.value.data[webhook.key]
          )[0][card.sellingPrice.key]
          : placeholders.zeroPrice
      return !asyncPrice ||
      asyncPrice === 0 ||
      asyncPrice === placeholders.zeroPrice
        ? placeholders.zeroPrice
        : currencySymbol +
        " " +
        Utils.setNumberFormat(
          asyncPrice,
          priceFormat.decimals,
          priceFormat.dec_divider,
          priceFormat.migl_divider
        )
    }
    var priceToShow = ""
    if (props.value.pricing && props.value.pricing[card.sellingPrice.key])
      priceToShow =
        currencySymbol +
        " " +
        Utils.setNumberFormat(
          props.value.pricing[card.sellingPrice.key],
          priceFormat.decimals,
          priceFormat.dec_divider,
          priceFormat.migl_divider
        )
    else priceToShow = placeholders.zeroPrice
    return priceToShow
  }, [
    props,
    card,
    currencySymbol,
    placeholders,
    priceFormat,
    asyncData,
    webhook,
  ])

  const listingPriceToShow = useMemo(() => {
    if (webhook.key !== "" && asyncData) {
      var asyncPrice =
        asyncData.filter((item) => item.id === props.value.data[webhook.key])
          .length > 0
          ? asyncData.filter(
            (item) => item.id === props.value.data[webhook.key]
          )[0][card.listingPrice.key]
          : placeholders.zeroPrice
      return !asyncPrice ||
      asyncPrice === 0 ||
      asyncPrice === placeholders.zeroPrice
        ? placeholders.zeroPrice
        : currencySymbol +
        " " +
        Utils.setNumberFormat(
          asyncPrice,
          priceFormat.decimals,
          priceFormat.dec_divider,
          priceFormat.migl_divider
        )
    }
    if (
      props.value.pricing &&
      props.value.pricing[card.listingPrice.key] &&
      priceToShow !== 0 &&
      priceToShow !==
      currencySymbol +
      " " +
      Utils.setNumberFormat(
        props.value.pricing[card.listingPrice.key],
        priceFormat.decimals,
        priceFormat.dec_divider,
        priceFormat.migl_divider
      )
    )
      return (
        currencySymbol +
        " " +
        Utils.setNumberFormat(
          props.value.pricing[card.listingPrice.key],
          priceFormat.decimals,
          priceFormat.dec_divider,
          priceFormat.migl_divider
        )
      )
    return ""
  }, [
    placeholders,
    currencySymbol,
    card,
    props,
    priceFormat,
    asyncData,
    webhook,
    priceToShow,
  ])
  const discountAmount = useMemo(() => {
    if (
      card[automaticDiscount]?.isActive &&
      priceToShow !== listingPriceToShow &&
      listingPriceToShow !== ""
    ) {
      const discountPrice = priceToShow.replace(currencySymbol, "")?.trim()
      const fullPrice = listingPriceToShow.replace(currencySymbol, "")?.trim()
      let discount =
        ((Number(fullPrice) - Number(discountPrice)) * 100) / Number(fullPrice)
      return Math.round(discount)
    }
    return null
  }, [automaticDiscount, card, currencySymbol, listingPriceToShow, priceToShow])

  var imageToShow = useMemo(() => {
    if (
      !props.value.data ||
      !selectedProduct ||
      !props.value.data[card.img.key] ||
      props.value.data[card.img.key].length === 0 ||
      !card.img.isActive
    )
      return ""
    if (
      hover.isActive &&
      hovered &&
      hover.secondImage &&
      props.value.data &&
      selectedProduct &&
      typeof props.value.data[card.img.key] !== "string" &&
      props.value.data[card.img.key].length > 1
    ) {
      return props.value.data[card.img.key][1].replace("{:image}", imgPrefix)
    } else if (
      hover.changeImage &&
      (headerType === "configurable" || (hovered && headerType === "grouped"))
    ) {
      return selectedProduct &&
      selectedProduct[card.img.key] &&
      selectedProduct[card.img.key][0]
        ? selectedProduct[card.img.key][0].replace("{:image}", imgPrefix)
        : props.value.data[card.img.key][0].replace("{:image}", imgPrefix)
    } else {
      return props.value.data[card.img.key].length >= 1
        ? props.value.data[card.img.key][0].replace("{:image}", imgPrefix)
        : props.value.data[card.img.key].replace("{:image}", imgPrefix)
    }
  }, [props, selectedProduct, hover, card, hovered, imgPrefix, headerType])

  function SampleNextArrow(props) {
    const {className, onClick, itemsNumber, configurationsId} = props
    const [disabled, setDisabled] = useState(false)
    useEffect(() => {
      var fullWidth = $($("." + configurationsId)[0]).innerWidth()
      var configurationsWidth = 0
      for (var i = 0; i < itemsNumber; i++)
        configurationsWidth += $(
          $("." + configurationsId + " .slick-slide")[i]
        ).innerWidth()
      if (configurationsWidth < fullWidth) setDisabled(true)
      else setDisabled(false)
    }, [configurationsId, setDisabled, itemsNumber])
    return (
      <div
        className={className + " " + (disabled ? "slick-disabled" : "")}
        onClick={onClick}
      />
    )
  }

  function SamplePrevArrow(props) {
    const {className, onClick, itemsNumber, configurationsId} = props
    const [disabled, setDisabled] = useState(false)
    useEffect(() => {
      var fullWidth = $($("." + configurationsId)[0]).innerWidth()
      var configurationsWidth = 0
      for (var i = 0; i < itemsNumber; i++)
        configurationsWidth += $(
          $("." + configurationsId + " .slick-slide")[i]
        ).innerWidth()
      if (configurationsWidth < fullWidth) setDisabled(true)
      else setDisabled(false)
    }, [configurationsId, setDisabled, itemsNumber])
    return (
      <div
        className={className + " " + (disabled ? "slick-disabled" : "")}
        onClick={onClick}
      />
    )
  }

  const sliderSettings = useCallback((configurationsId, itemsNumber, type) => {
    return {
      className: "slider variable-width child " + configurationsId + " " + type,
      dots: false,
      infinite: false,
      speed: 200,
      slidesToScroll: 1,
      slidesToShow: 1,
      variableWidth: true,
      nextArrow: (
        <SampleNextArrow
          configurationsId={configurationsId}
          itemsNumber={itemsNumber}
        />
      ),
      prevArrow: (
        <SamplePrevArrow
          configurationsId={configurationsId}
          itemsNumber={itemsNumber}
        />
      ),
    }
  }, [])

  const onMouseHandler = useCallback(
    (isEntering) => {
      setHovered(isEntering)
      if (isEntering)
        setSelectedProduct(
          headerType === "simple" || !children[0]
            ? props.value.data
            : children[0].data
        )
      if (!isEntering && counter >= 3) {
        Utils.sendAnalyticsObject(baseUrl, shopId, "as_hover_product", {
          id: props.value.header.id,
          title: props.value.data[card.title.key],
          seconds: counter,
        })
        if (!!ga4?.isActive) {
          if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
            window.dataLayer.push({
              event: "as_hover_product",
              data: {
                id: props.value.header.id,
                title: props.value.data[card.title.key],
                seconds: counter,
              },
            })
          } else if (typeof gtag !== "undefined") {
            gtag("event", "as_hover_product", {
              id: props.value.header.id,
              title: props.value.data[card.title.key],
              seconds: counter,
            })
          }
        }
      }
      setCounter(1)
    },
    [
      setHovered,
      setCounter,
      setSelectedProduct,
      headerType,
      card,
      props,
      shopId,
      baseUrl,
      counter,
      children,
    ]
  )

  const getParameterIndex = useCallback(
    (value) => {
      var valueToReturn = -1
      Object.keys(card).forEach((item, index) => {
        if (value === item) {
          valueToReturn = index
          return false
        }
      })
      return valueToReturn
    },
    [card]
  )

  function handleClick() {
    const dataToSave = {
      categories: props.value.categories,
      pricing: props.value.pricing,
      data: props.value.data,
    }
    cookies.set("ASLastClickedProduct", JSON.stringify(dataToSave), {
      maxAge: 604800,
    })
    sessionStorage.setItem("isLayerOpen", "false")
    Utils.sendAnalyticsObject(baseUrl, shopId, "as_click_product", {
      id: props.value.header.id,
      title: props.value.data[card.title.key],
    })
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({
          event: "as_click_product",
          data: {
            id: props.value.header.id,
            title: props.value.data[card.title.key],
          },
        })
      } else if (typeof gtag !== "undefined") {
        gtag("event", "as_click_product", {
          id: props.value.header.id,
          title: props.value.data[card.title.key],
        })
      }
    }
  }

  function handlePromotionClick() {
    sessionStorage.setItem("isLayerOpen", "false")
    Utils.sendAnalyticsObject(baseUrl, shopId, "as_click_promotion", {
      id: props.value.header.id,
      name: props.value.header.name,
      type: "card",
      device: isMobile ? "mobile" : "desktop",
    })
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({
          event: "as_click_promotion",
          data: {
            id: props.value.header.id,
            name: props.value.header.name,
            type: "card",
            device: isMobile ? "mobile" : "desktop",
          },
        })
      } else if (typeof gtag !== "undefined") {
        gtag("event", "as_click_promotion", {
          id: props.value.header.id,
          name: props.value.header.name,
          type: "card",
          device: isMobile ? "mobile" : "desktop",
        })
      }
    }
  }

  return headerType !== "banner" ? (
    <div
      className={
        "product-card" +
        (!loaded ? " loading" : "") +
        (hovered && hover.isActive ? " hovered" : "")
      }
      id={props.id}
      tabIndex={0}
      onMouseEnter={() => (loaded ? onMouseHandler(true) : null)}
      onMouseLeave={() => (loaded ? onMouseHandler(false) : null)}
    >
      {configurationActive
        ? stickers.map((item, index) => {
          return props.value.data && props.value.data[item.field] ? (
            <Sticker
              value={item}
              key={"sticker_" + props.value.data.name + "_" + index}
            />
          ) : null
        })
        : null}
      {card.img.isActive ? (
        <a
          href={
            props.value.data
              ? props.value.data[card.url.key].replace("{:url}", urlPrefix)
              : ""
          }
          onClick={() => {
            handleClick()
          }}
        >
          {isError ? (
            <img
              loading="lazy"
              className={"img placeholder"}
              src={placeholder}
              alt={selectedProduct ? selectedProduct[card.title.key] : ""}
              id={props.value.header.id}
              onLoad={() => {
                if (fallback)
                  setTimeout(() => {
                    setIsError(false)
                    setFallback(false)
                  }, 250)
              }}
            />
          ) : (
            <img
              className={"img"}
              loading="lazy"
              src={imageToShow}
              alt={selectedProduct ? selectedProduct[card.title.key] : ""}
              onError={({currentTarget}) => {
                if (props.value.header && errorId !== props.value.header.id)
                  setErrorId(props.value.header.id)
                setIsError(true)
              }}
            />
          )}
        </a>
      ) : null}

      {discountAmount && (
        <div
          className="discount-percentage"
          style={{backgroundColor: accentColor}}
        >
          {discountAmount}&nbsp;%
        </div>
      )}

      {props.value.data && (
        <>
          {configurationActive
            ? <div className="info-container">
              {card.isinstock.isActive > 0 && (
                <div
                  style={{order: getParameterIndex("isinstock")}}
                  className={
                    "stock " +
                    (props.value.data[card.isinstock.key] <= 0 ||
                    props.value.data[card.isinstock.key] === "0" ||
                    props.value.data[card.isinstock.key] === "out of stock" ||
                    props.value.data[card.isinstock.key] === "out-of-stock" ||
                    props.value.data[card.isinstock.key] === "out_of_stock" ||
                    !props.value.data[card.isinstock.key]
                      ? "outOfStock"
                      : "inStock")
                  }
                >
                  {" "}
                  <div></div>
                  {" "}
                  {props.value.data[card.isinstock.key] <= 0 ||
                  props.value.data[card.isinstock.key] === "0" ||
                  props.value.data[card.isinstock.key] === "out of stock" ||
                  props.value.data[card.isinstock.key] === "out-of-stock" ||
                  props.value.data[card.isinstock.key] === "out_of_stock" ||
                  !props.value.data[card.isinstock.key]
                    ? placeholders.outOfStock
                    : placeholders.inStock}{" "}
                </div>
              )}

              {card.rating.isActive && (
                <div
                  style={{order: getParameterIndex("rating")}}
                  className="rating"
                >
                  {props.value.data[card.rating.key]}
                </div>
              )}

              {card.type.isActive && (
                <div className="type" style={{order: getParameterIndex("type")}}>
                  {props.value.data[card.type.key]}
                </div>
              )}

              {card.title.isActive && (
                <div
                  className="title"
                  style={{order: getParameterIndex("title")}}
                >
                  {props.value.data[card.title.key]}
                </div>
              )}

              {card.desc.isActive && (
                <div
                  className="desc"
                  style={{order: getParameterIndex("desc")}}
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof props.value.data[card.desc.key] === "string"
                        ? props.value.data[card.desc.key]
                        : props.value.data[card.desc.key]
                          ? props.value.data[card.desc.key][0]
                          : "",
                  }}
                ></div>
              )}

              {card.sku.isActive && (
                <div className="sku" style={{order: getParameterIndex("sku")}}>
                  {props.value.data[card.sku.key]}
                </div>
              )}

              {card.brand.isActive && (
                <div
                  className="brand"
                  style={{order: getParameterIndex("brand")}}
                >
                  {props.value.data[card.brand.key]}
                </div>
              )}

              {card.custom.isActive && (
                <div
                  className={card.custom.key}
                  style={{order: getParameterIndex("custom")}}
                >
                  {props.value.data[card.custom.key]}
                </div>
              )}

              {webhook.key !== "" && asyncData.length === 0 && visitorType
                ? <div className="price_container loading"/>
                : (
                  <div className="price_container"
                       style={{
                         height: showAddToCartBtn ? 'auto' : 30,
                       }}
                  >
                    <PriceContainer
                      data={props.value}
                      headerType={headerType}
                      listingPriceToShow={listingPriceToShow}
                      priceToShow={priceToShow}
                    />
                  </div>
                )}
            </div>
            : (
              <div
                className="variants-container"
                onClick={(evt) => {
                  evt.preventDefault()
                }}
              >

                {card.title.isActive && (
                  <div className="title"> {props.value.data[card.title.key]} </div>
                )}

                {headerType === "bundle" ? (
                  childrenToUse.map((child, index) => (
                    <div
                      className="child"
                      key={"child_" + child.items[0][card.sku.key] + "_" + index}
                    >
                      {child?.items[0]?.configurableAttributes?.length > 0 ? (
                        <div>
                          {getBundleConfigurations(child.items).map(
                            (configuration) => (
                              <div
                                className={
                                  "configurations-container " +
                                  configuration.configurableAttribute
                                }
                                key={
                                  "bundle_configuration_" +
                                  configuration.configurableAttribute
                                }
                              >
                                {configuration.items.map((item, index) => (
                                  <Configuration
                                    type={headerType}
                                    key={
                                      "bundle_configuration_" +
                                      configuration.configurableAttribute +
                                      "_" +
                                      index
                                    }
                                    child={item}
                                    upperProduct={selectedProduct}
                                    selectedProduct={selectedProduct}
                                    configurableAttribute={
                                      configuration.configurableAttribute
                                    }
                                  />
                                ))}
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        <div>{child.items[0].data[card.title.key]}</div>
                      )}
                    </div>
                  ))
                ) : headerType === "grouped" ? (
                  <Slider
                    {...sliderSettings(
                      headerId + "_grouped_child_",
                      children.settings,
                      headerType
                    )}
                  >
                    {children.map((child, index) => (
                      <Configuration
                        key={"grouped_child_" + index}
                        child={child}
                        setSelectedProduct={() =>
                          setSelectedProduct(props.value.bundles[index].data)
                        }
                        selectedProduct={child.data}
                        upperProduct={selectedProduct}
                        type={headerType}
                        configurableAttribute={"grouped_child_"}
                      />
                    ))}
                  </Slider>
                ) : (
                  Object.keys(childrenToUse).map((configurableAttribute, index) => (
                    <Slider
                      {...sliderSettings(
                        headerId + "_" + configurableAttribute,
                        childrenToUse[configurableAttribute].length,
                        headerType
                      )}
                      key={"child_" + configurableAttribute + "_" + index}
                    >
                      {childrenToUse[configurableAttribute].map((child, subIndex) => (
                        <Configuration
                          key={
                            "configuration_" + configurableAttribute + "_" + subIndex
                          }
                          child={child}
                          upperProduct={selectedProduct}
                          selectedProduct={Utils.getSelectedProductFromConf(
                            children,
                            selectedProduct,
                            configurableAttribute,
                            Object.keys(childrenToUse),
                            child,
                            index
                          )}
                          configurableAttribute={configurableAttribute}
                          setSelectedProduct={(conf) =>
                            setSelectedProduct(
                              Utils.getSelectedProductFromConf(
                                children,
                                selectedProduct,
                                configurableAttribute,
                                Object.keys(childrenToUse),
                                conf,
                                index
                              )
                            )
                          }
                          type={headerType}
                          index={subIndex}
                          isImpossible={Utils.checkImpossibleConfiguration(
                            index,
                            child,
                            selectedProduct,
                            Object.keys(childrenToUse),
                            children
                          )}
                        />
                      ))}
                    </Slider>
                  ))
                )}

                {webhook.key !== "" && asyncData.length === 0 && visitorType
                  ? <div className="price_container loading"/>
                  : (
                    <div className="price_container">
                      <PriceContainer
                        data={{
                          ...props.value, selectedProduct
                        }}
                        headerType={headerType}
                        listingPriceToShow={listingPriceToShow}
                        priceToShow={priceToShow}
                      />
                    </div>
                  )}
              </div>
            )}
        </>
      )}
    </div>
  ) : (
    <div
      className="product-card promo"
      onClick={() => handlePromotionClick()}
      ref={promoRef}
    >
      <a target="_blank" rel="noopener noreferrer" href={props.value.data.url}>
        {" "}
        <img src={bannerResponsive} alt={bannerResponsive}/>{" "}
      </a>
    </div>
  )
}

function PriceContainer({listingPriceToShow, data, headerType, priceToShow}) {
  const addToCartBtn = useSelector((state) => state.config.addToCartBtn);
  const card = useSelector((state) => state.config.card);
  const placeholders = useSelector((state) => state.config.placeholders);
  const isMobile = useSelector((state) => state.isMobile)

  const {
    type: addToCartBtnType,
    display: showAddToCartBtn = false,
  } = addToCartBtn || {};

  const hasSpecialPrice = card.listingPrice.isActive &&
    listingPriceToShow !== "" &&
    listingPriceToShow !== placeholders.zeroPrice;

  if (showAddToCartBtn) {
    return (
      <>
        {!isMobile && addToCartBtnType === 'full-btn'
          ? <FullBtn data={data}/>
          : <IconBtn data={data}/>
        }

        <div className={addToCartBtn ? "price-wrapper" : undefined}>
          {hasSpecialPrice && (
            <div
              className={
                "special_price " +
                (listingPriceToShow === priceToShow ? "same-price" : "")
              }
              style={{
                fontSize: 12
              }}
            >
              <del>{listingPriceToShow}</del>
            </div>
          )}
          {card.sellingPrice.isActive && priceToShow !== 0 && (
            <div
              className="price"
              style={{
                fontSize: hasSpecialPrice ? 12 : undefined
              }}
            >
              {headerType === "grouped" && <span>Starting from</span>}

              {" "}

              {priceToShow}
            </div>
          )}
        </div>
      </>
    );
  }

  return (
    <>
      {hasSpecialPrice && (
        <div
          className={
            "special_price " +
            (listingPriceToShow === priceToShow ? "same-price" : "")
          }
        >
          <del>{listingPriceToShow}</del>
        </div>
      )}
      {card.sellingPrice.isActive && priceToShow !== 0 && (
        <div className="price">
          {headerType === "grouped" && <span>Starting from</span>}

          {" "}

          {priceToShow}
        </div>
      )}
    </>
  );
}

function FullBtn({data}) {
  const accentColor = useSelector((state) => state.config.accentColor);
  const addToCartBtn = useSelector((state) => state.config.addToCartBtn);

  const {isLoading, currentSku, isSuccess, isError} = useAddToCartStatus();
  const sku = data.data.id;
  const isThisLoading = isLoading && currentSku === sku;
  const isThisShowingStatus = (isSuccess || isError) && currentSku === sku;

  const {
    foregroundColor: addToCartBtnForegroundColor,
    backgroundColor: addToCartBtnBackgroundColor,
    label: addToCartBtnLabel,
    errorMsg,
    successMsg,
    errorBackgroundColor,
    successBackgroundColor
  } = addToCartBtn || {};

  const handleOnAddToCartClick = () => {
    if (window.addToCart) {
      window.addToCart(data);
    }
  };

  const buttonContent = isThisShowingStatus
    ? isSuccess
      ? successMsg || 'Aggiunto!'
      : errorMsg || 'Errore!'
    : addToCartBtnLabel || 'Aggiungi al carrello';

  const backgroundColor = (() => {
    if (isThisShowingStatus) {
      if (isSuccess) {
        return successBackgroundColor || '#00FF00';
      } else if (isError) {
        return errorBackgroundColor || '#FF0000';
      }
    } else if (isLoading) {
      return '#BDBDBD';
    } else {
      return addToCartBtnBackgroundColor || accentColor;
    }
  })();

  return (
    <button
      type="button"
      disabled={isLoading}
      className="addtocart-btn"
      onClick={handleOnAddToCartClick}
      style={{
        backgroundColor,
        color: addToCartBtnForegroundColor || '#000000',
        fontStyle: isLoading ? 'italic' : undefined,
        cursor: isLoading ? 'not-allowed': 'pointer'
      }}
    >
      {isThisLoading
        ? <Spinner />
        : buttonContent
      }
    </button>
  );
}

function IconBtn({data}) {
  const accentColor = useSelector((state) => state.config.accentColor);
  const addToCartBtn = useSelector((state) => state.config.addToCartBtn);

  const {
    foregroundColor: addToCartBtnForegroundColor,
    backgroundColor: addToCartBtnBackgroundColor,
    iconSize: addToCartBtnIconSize,
    errorBackgroundColor,
    successBackgroundColor
  } = addToCartBtn || {};

  const {isLoading, currentSku, isSuccess, isError} = useAddToCartStatus();
  const sku = data.data.id;
  const isThisLoading = isLoading && currentSku === sku;
  const isThisShowingStatus = (isSuccess || isError) && currentSku === sku;

  const handleOnAddToCartClick = () => {
    if (window.addToCart) {
      window.addToCart(data);
    }
  };

  const backgroundColor = (() => {
    if (isThisShowingStatus) {
      if (isSuccess) {
        return successBackgroundColor || '#00FF00';
      } else if (isError) {
        return errorBackgroundColor || '#FF0000';
      }
    } else if (isLoading) {
      return '#BDBDBD';
    } else {
      return addToCartBtnBackgroundColor || accentColor;
    }
  })();

  return (
    <button
      type="button"
      className="addtocart-btn"
      disabled={isLoading}
      onClick={handleOnAddToCartClick}
      style={{
        backgroundColor,
        cursor: isLoading ? 'not-allowed': 'pointer'
      }}
    >
      {isThisLoading
        ? <Spinner />
        : (
          <CartIcon
            color={addToCartBtnForegroundColor || '#000000'}
            size={addToCartBtnIconSize || 20}
          />
        )
      }
    </button>
  );
}

export default ProductCard
